import React from 'react'
import { connect } from 'react-redux'
import Players from '../components/players'

const mapStateToProps = (state) => ({
  ...state.players
})

const mapDispatchToProps = dispatch => ({
  loadPlayers: payload => dispatch({type: 'PLAYERS.LOAD', payload}),
  onPageChange: (payload) => dispatch({type: 'PLAYERS.PAGE_CHANGE', payload: payload}),
  onPlayerUpdate: (payload) => dispatch({type: 'PLAYERS.PLAYER_UPDATE', payload: payload}),
  onPlayerDelete: (payload) => dispatch({type: 'PLAYERS.PLAYER_DELETE', payload: payload}),
  onConditions: (payload) => dispatch({type: 'PLAYERS.ON_CONDITIONS', payload: payload}),
  onSearch: (payload) => dispatch({type: 'PLAYERS.SEARCH', payload: payload}),
  loadViews: () => dispatch({type: 'PLAYERS.LOAD_VIEWS'}),
  onUpdateView: (payload) => dispatch({type: 'PLAYERS.PROCESS_VIEW', payload: payload}),
  onDeleteView: (payload) => dispatch({type: 'PLAYERS.DELETE_VIEW', payload: payload}),
  clearAlert: () => dispatch({type: 'PLAYERS.CLEAR_ALERT'}),
  setCurrentView: (payload) => dispatch({type: 'PLAYERS.SET_CURRENT_VIEW', payload: payload}),
  clearCurrentView: () => dispatch({type: 'PLAYERS.CLEAR_CURRENT_VIEW'}),
  onEditView: (payload) => dispatch({type: 'PLAYERS.EDIT_VIEW', payload: payload}),
  onImportCredits: (payload) => dispatch({type: 'PLAYERS.IMPORT_CREDITS', payload: payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(Players)
